import React, { useState } from 'react';
import { Dialog, DialogContent, DialogActions, Typography, TextField, Button } from '@mui/material';

const DenyReasonDialog = ({
  open,
  onClose,
  onSubmit,
  loading = false,
  confirmLabel = 'Submit Denial',
  cancelLabel = 'Cancel',
}) => {
  const [note, setNote] = useState('');

  const handleConfirm = () => {
    if (note.trim()) {
      onSubmit(note.trim());
      setNote('');
    }
  };

  const handleCancel = () => {
    setNote('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogContent sx={{ pb: 0 }}>
        <Typography sx={{ mb: 2 }}>
          Please enter a reason for denying this request. This note will be saved to the Appover Notes Column.
        </Typography>
        <TextField
          multiline
          fullWidth
          minRows={3}
          maxRows={8}
          placeholder="Enter your notes here..."
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={handleCancel} disabled={loading} variant="contained" color="warning">
          {cancelLabel}
        </Button>
        <Button onClick={handleConfirm} disabled={loading || !note.trim()} variant="contained" color="primary">
          {loading ? 'Submitting...' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DenyReasonDialog;
